import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import Skeleton from "@saleor/components/Skeleton";
import { FormChange } from "@saleor/hooks/useForm";
import { FetchMoreProps } from "@saleor/types";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

import { SellerBrandFormData } from "../HomePage";
const useStyles = makeStyles(
  theme => ({
    headerContainer: {
      marginBottom: theme.spacing(3)
    },
    pageHeader: {
      "@media (max-width: 767px)": {
        fontSize: "25px"
      },
      fontWeight: 600 as 600
    },
    subtitle: {
      color: theme.typography.caption.color
    }
  }),
  { name: "HomeHeader" }
);

interface HomeOrdersCardProps {
  brandID: string;
  sellerDisplayValue: string;
  userName: string;
  user: any;
  change: any;
  submit: any;
  brands: SingleAutocompleteChoiceType[];
  data: SellerBrandFormData;
  fetchBrands: (query: string) => void;
  fetchMoreBrands?: FetchMoreProps;
  // onBrandChange(event: React.ChangeEvent<any>);
  onBrandChange: FormChange;
}

const HomeOrdersCard: React.FC<HomeOrdersCardProps> = props => {
  const {
    data: formData,
    brandID,
    brands,
    fetchBrands,
    fetchMoreBrands,
    onBrandChange,
    sellerDisplayValue,
    user,
    userName
  } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad && brands && brands.length) {
      setFirstLoad(false);
      if (
        sellerDisplayValue !== "" &&
        brandID !== null &&
        brandID !== undefined
      ) {
        const newEvent = { target: { name: "sellerBrand", value: brandID } };
        onBrandChange(newEvent);
      }
      if (
        brands &&
        brands.length &&
        sellerDisplayValue === "" &&
        brandID === null
      ) {
        const newEvent = {
          target: { name: "sellerBrand", value: brands[0].value }
        };
        onBrandChange(newEvent);
      }
    }
  }, [brands, sellerDisplayValue]);

  return (
    <div className={classes.headerContainer} data-test="home-header">
      {user.userType.code === "ACCOUNT_MANAGER" && (
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: "auto", order: 2, width: "300px" }}>
            <SingleAutocompleteSelectField
              label={intl.formatMessage({
                defaultMessage: "Seller (Brand)*"
              })}
              name="sellerBrand"
              displayValue={sellerDisplayValue}
              choices={brands}
              disabled={false}
              value={formData.sellerBrand}
              onChange={event => {
                onBrandChange(event);
                // onBrandChangeStoreType(event);
              }}
              fetchChoices={fetchBrands}
              {...fetchMoreBrands}
              // error={!!error.sellerBrand}
              // helperText={error.sellerBrand}
            />
          </div>
        </div>
      )}
      <Typography
        className={classes.pageHeader}
        variant="h4"
        data-test="welcomeHeader"
      >
        {userName ? (
          <FormattedMessage
            defaultMessage="Hello there, {userName}"
            description="header"
            id="homeHeaderText"
            values={{
              userName
            }}
          />
        ) : (
          <Skeleton style={{ width: "10em" }} />
        )}
      </Typography>
      <Typography className={classes.subtitle}>
        {userName ? (
          <FormattedMessage
            defaultMessage="Here is some information we gathered about your store"
            description="subheader"
            id="homeHeaderTextCaption"
          />
        ) : (
          <Skeleton style={{ width: "10em" }} />
        )}
      </Typography>
    </div>
  );
};
HomeOrdersCard.displayName = "HomeOrdersCard";
export default HomeOrdersCard;
